/**
 * @module お問い合せ共通コンポーネント
 */
import ListPanel from '@/components/listPanel/ListPanel.vue';
import PCFooter from '@/components/footer/PCFooter';
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';
import CONSTANTS from '../../constants';

export default {
  name: 'Contact',
  components: {
    ListPanel,
    PCFooter,
  },
  data: () => ({
    telephoneImage: require('@/assets/images/icon/telephone01.png'),
    width: 0,
  }),
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    clientNumber: {
      type: String,
      default: '',
      required: false,
    },
    displayAreaTitle: {
      type: Object,
      default: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      required: false,
    },
    displayAreaList: {
      type: Array,
      required: false,
    },
    cameraTitle: {
      type: String,
      default: '',
      required: false,
    },
    cameraList: {
      type: Array,
      required: false,
    },
    securityStatus: {
      type: String,
      default: '',
      required: false,
    },
    warningOccurred: {
      type: String,
      default: '',
      required: false,
    },
    isAlert: {
      type: Boolean,
      default: false,
      required: false,
    },
    lockUp: {
      type: String,
      default: '',
      required: false,
    },
    isLockUp: {
      type: Boolean,
      default: false,
      required: false,
    },
    userType: {
      type: Number,
      default: 0,
      required: false,
    },
    notificationCount: {
      type: Number,
      default: 0,
      required: false,
    },
    notificationColor: {
      type: String,
      default: '',
      required: false,
    },
    notificationImage: {
      type: String,
      required: false,
    },
    usagePlan: {
      type: Number,
      default: 0,
      required: false,
    },
    originalPlan: {
      //#27540
      type: Number,
      default: -1,
      required: false,
    },
    guardCenterName: {
      type: String,
      default: '',
      required: false,
    },
    guardCenterPhoneNumber: {
      type: String,
      default: '',
      required: false,
    },
    orderedOfficeName: {
      type: String,
      default: '',
      required: false,
    },
    orderedOfficePhone: {
      type: String,
      default: '',
      required: false,
    },
    orderedGcName: {
      type: String,
      default: '',
      required: false,
    },
    orderedGcPhone: {
      type: String,
      default: '',
      required: false,
    },
    contactPage: {
      type: Boolean,
      default: false,
      required: false,
    },
    displayType: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  mounted() {
    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });
  },
  /** @type {Methods} */
  methods: {
    /**
     * 電話アプリでコール
     * @description スマホアプリの場合のみ電話アプリを起動してコール
     * @param {String} tel 電話番号
     */
    call(tel) {
      //check isMobileApp in case ipad device
      if (this.$isMobile || this.$isMobileApp) {
        // 画面設計書_FE-CU16_かけつけ依頼画面から遷移してきた場合のみ、以下の考慮を行う。
        //   1. オンライン監視プランの場合
        //    対象地区の担当ガードセンターの連絡先を表示。
        //  2. 依頼かけつけプランの場合
        //    トパーズセンターの連絡先を表示。
        NativeApi.openTelApp(tel); // 電話アプリを起動
      }
    },
    /**
     * widthを調整
     * @param {object} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
    /**
     * 外部リンクを開く
     */
    clickAlsok() {
      const url = 'https://www.alsok.co.jp/company/info/office/';
      if (!this.$isMobileApp) {
        window.open(url, '_blank'); // 別タブで外部リンクを開く
      } else {
        NativeApi.openBrowserApp(url);
      }
    },
  },
  computed: {
    nativeError() {
      return this.$store.getters['appInfo/getNativeError'].errorCode;
    },
  },
  watch: {
    nativeError(newVal) {
      if (NativeCallback.codeInclude(newVal, '10-E0002')) {
        // 電話アプリ起動失敗時
        this.$errorDialog(
          '$vuetify.messageDialog.アプリの起動に失敗しました'
          // "アプリの起動に失敗しました。もう一度電話番号ボタンを押してください。",
        );
      } else if (NativeCallback.codeInclude(newVal, '10-E0001')) {
        // 外部リンクブラウザ起動失敗時
      }
      this.$store.commit('appInfo/setNativeError', { errorCode: '' });
    },
  },
};
